import React, {useEffect, useState} from 'react'
import {RangeSlider} from '../../../../../../components/UI'
import {SelectTipo} from './SelectTipo'
import {ColorPicker} from '../../../../../../components/UI/ColorPicker'
import {Modal, Offcanvas} from 'react-bootstrap'
import Scrollbars from 'react-custom-scrollbars-2'
import {FaBed, FaCarSide, FaFilter, FaShower} from 'react-icons/fa'
import {GetAcessoUsuarioProduto} from '../../../../../../utils/PermissoesAcesso'
import {MensagemAlertAcesso} from '../../../../../../components/UI/MensagemAlertAcesso'
import { SelectIncorporadoras } from './SelectIncorporadoras'
import { SelectTipoUsado } from './SelectTipoUsado'
import { SelectFinalidade } from './SelectFinalidade'

type Props = {
  show: boolean
  onChangeFiltro: any
  onAdicionarCamada: any
  onHandleClose: any
}

export const FiltrosImovelUsadoModalAluguel: React.FC<Props> = ({
  show,
  onChangeFiltro,
  onAdicionarCamada,
  onHandleClose,
}) => {
   
  useEffect(()=>{
    onChangeFiltro('finalidade', 'aluguel', 'update', 'select')
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[show])

  
  const permissao = GetAcessoUsuarioProduto(31)
  return (
    <Modal centered animation show={show} onHide={() => onHandleClose()}>
      <Modal.Header closeButton>
        <Modal.Title>Adicionar camada de Imóveis Usados - Aluguel</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className='row px-10'>
          <div className='row g-1 align-items-center mt-5'>
            <div className='col-4'>
              <label className='col-form-label'>Nome:</label>
            </div>
            <div className='col-8'>
              <input
                type='text'
                className='form-control'
                name='nome_camada'
                id='nome_camada'
                onChange={(e) =>{
                  onChangeFiltro('nomeCamada', e.target.value, 'update', 'text', '#ff0000')
                }}
                placeholder='Digite o nome da camada'
              />
            </div>
          </div>

          <div className='row g-1 mt-5 align-items-center'>
            <div className='col-4'>Tipo</div>
            <div className='col-8'>
              <SelectTipoUsado
                idTipo={0}
                onChange={(e) => onChangeFiltro('tipo', e, 'update', 'select')}
              ></SelectTipoUsado>
            </div>
          </div>
          {/* <div className='row g-1 mt-5 align-items-center'>
            <div className='col-4'>Finalidade</div>
            <div className='col-8'>
              <SelectFinalidade
                idFinalidade={0} 
                onChange={(e) => onChangeFiltro('finalidade', e, 'update', 'select')} 
                            >

                </SelectFinalidade>
            </div>
          </div> */}
         

          <div className='row g-1 pt-5'>
            <div className='col-4'>
              <label className='col-form-label'>Útilmos dias </label>
            </div>
            <div className='col-8 p-0 '>
              <RangeSlider
                defaultValue={[0, 90]}
                min={0}
                max={90}
                step={1}
                formatTip={(value) => `${value} `}
                onChange={(e) => {
                  onChangeFiltro('dias_coleta', e, 'update', 'range')
                }}
                showHideImput={false}
              />
            </div>
          </div>
           <div className='row g-1 align-items-center pt-5 pb-5'>
              <div className='col-4'>
                <label className='col-form-label'>Cor:</label>
              </div>
              <div className='col-8'>
                <ColorPicker
                  hex={'#080606'}
                  hsl={''}
                  onChange={(e) => onChangeFiltro('cor', e, 'update', 'text', e)}
                ></ColorPicker>
                {/* <RangeSlider
                  value={}
                  onChange={(changeEvent) => {
                    let val = changeEvent.target.value
                    setOpacity(parseInt(val))
                    onChangeOpacity()
                  }}
                  min={0}
                  max={100}
                  step={5}
                /> */}
              </div>
            </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className='row align-items-end pt-5'>
          {permissao ? (
            <button className='btn btn-sm btn-primary fw-bold' onClick={onAdicionarCamada}>
              <FaFilter></FaFilter>
              Adicionar Camada
            </button>
          ) : (
            <MensagemAlertAcesso mensagem='Somente para assinantes do Produto - Plano Órulo - Lançamentos.'></MensagemAlertAcesso>
          )}
        </div>
      </Modal.Footer>
    </Modal>
  )
}
